import { ChainURL } from '@ankr.com/chains-list';

import { EndpointGroup } from 'modules/endpoints/types';
import { Technology } from 'modules/chains/constants';

import { templatesMap, urlPlaceHolder } from '../const';

const defaultUrls = { rpc: '', ws: '' };

const notPublicUrlsSuffix = '/apiKey';

interface IGetCodeMrpcParams {
  technology: Technology;
  urls: ChainURL[];
  shouldAddPrefix: boolean;
}

export const getCodeMrpc = ({
  shouldAddPrefix,
  technology,
  urls,
}: IGetCodeMrpcParams): [string, string] => {
  const [{ rpc, ws } = defaultUrls] = urls;
  const [httpCode, wssCode] = templatesMap[technology];

  return [
    rpc
      ? httpCode.replace(
          urlPlaceHolder,
          shouldAddPrefix ? rpc.concat(notPublicUrlsSuffix) : rpc,
        )
      : '',
    ws
      ? wssCode.replace(
          urlPlaceHolder,
          shouldAddPrefix ? ws.concat(notPublicUrlsSuffix) : ws,
        )
      : '',
  ];
};

export const getCodeEnterprise = (
  technology: Technology,
  { urls: [{ enterprise, enterpriseWs }] }: EndpointGroup,
) => {
  const [httpCode, wssCode] = templatesMap[technology];

  return [
    httpCode.replace(urlPlaceHolder, enterprise),
    wssCode.replace(urlPlaceHolder, enterpriseWs),
  ];
};
